import { map } from 'rxjs/operators';

const toOptions = map((entities: any[]) => {
  return entities.map((entity) => ({
    entity,
    label: entity.name,
    value: entity.id,
  }));
});

export { toOptions };
export default toOptions;
